import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/shareIcons/bolt.svg'


const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "w-p450" }
const _hoisted_4 = { class: "row w-full" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  style: {"width":"1.5rem"}
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 0,
  style: {"width":"1.5rem"}
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 0,
  style: {"width":"1.5rem"}
}
const _hoisted_13 = { class: "row" }

import showAnnotations from '@/views/patientMain/showAnnotations.vue'
import refSheetGroup from '../../combinedReference/refSheetGroup.vue'
import docBioAddLists from './docBioAddLists.vue'

import { ref, computed, watch, onBeforeUnmount } from 'vue'
import gen from "@/functions/general.js"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import patientapi from "@/api/patientapi"
import { useAppUserStore } from '@/stores/appUser'
import { useI18n } from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'docBioAddOn',
  props: {
  filteredRefSheets: {
    type: Object,
    default: null,
  },
},
  setup(__props) {

const { t } = useI18n();

const appUserStore = useAppUserStore()
const currentEntryStore = useCurrentEntryStore()

const props = __props

const dropd = ref("")
const bioInputRef = ref(null)
const pendingToAdd = new Map()    // key: originalText.toLowerCase(), value: { conclusionGroupId, originalText }
const pendingToDelete = new Map() // key: expression_CclId, value: { expression_CclId, entryId }

const cclRow = ref([])
function getSuggestionsFromCclText() {
  cclRow.value = []
  const bioSuggFromCclText = currentEntryStore.currCclSuggestionsFromCclText?.bio
    ?.map(linkPrescribedExprToSugg)
  cclRow.value = bioSuggFromCclText
}

const currCclGroupId = computed(() =>currentEntryStore.currentCcl?.conclusionGroupId.toString() || currentEntryStore.currentNullCclId.toString());

const bioContentText = ref("")

function clearBioSearch() {
  bioContentText.value = ''
  bioInputRef.value.innerRef.focus()
}

function switchBioRowPrescription(row) {
  const allPrescribed = row.every(expr => expr.active);
  row.forEach((expr, index) => {
    if (allPrescribed || !expr.active) {
      switchSingleBioPrescription(row, index);
    }
  });
}

function switchSingleBioPrescription(row, itemIndex) {
  const entryId = currentEntryStore.currentEntryId;
  const suggExpr = row[itemIndex]
  const originalText = suggExpr.originalText;

  if (suggExpr.active) {
    suggExpr.active = false
    // Check if this was just added (cancel out)
    if (pendingToAdd.has(originalText)) {
      pendingToAdd.delete(originalText)
      return;
    }
    //Delete only if expression_CclId
    if (suggExpr.expression_CclId) {
      pendingToDelete.set(suggExpr.expression_CclId, {
        expression_CclId: suggExpr.expression_CclId,
        entryId
      })
    }
  } else {
    suggExpr.active = true
    const conclusionGroupId = currCclGroupId.value
    // Check if this was just deleted (cancel out)
    if (suggExpr.expression_CclId && pendingToDelete.has(suggExpr.expression_CclId)) {
      pendingToDelete.delete(suggExpr.expression_CclId)
    } else {
      // Track addition
      pendingToAdd.set(originalText, {
        conclusionGroupId,
        originalText
      })
    }
  }
}


const prescribedBioExprs = computed(() => {
  if (!currentEntryStore.hasCurrentEntry || !currentEntryStore.currentCcl) {return []}
  
  return currentEntryStore.currentCcl.bioPrescrArr;
})

const bioSuggestionsFromRefSheets = ref(null)
function createBioSuggestionsFromRefSheet() {
  bioSuggestionsFromRefSheets.value = null
  if (!props.filteredRefSheets) return;

  //Bio
  // const isBio = (expr) => {return expr.findingProcedureRoot === "Lab" || !["Imaging", "General"].includes(expr.findingProcedureRoot)}
  // const isBio = (expr) => {return expr.findingProcedureRoot === "Lab" || ["Specimen", "None"].includes(expr.siteFindingRoot)}
  const isBio = (expr) => {return expr.findingProcedureRoot === "Lab"
    || (["None"].includes(expr.siteRoot) && !["Imaging", "General"].includes(expr.findingProcedureRoot) && ["None"].includes(expr.healthProType))
  }
  let refSheetWithTypeGroups = []
  props.filteredRefSheets.forEach(refSheet => {
    refSheetWithTypeGroups.push(createRefSheetWithTypeGroup(refSheet, 'Presentation', ['sctPresentation1', 'sctPresentation2'], isBio))
    refSheetWithTypeGroups.push(createRefSheetWithTypeGroup(refSheet, 'Etio', ['sctEtio1', 'sctEtio2'], isBio))
    refSheetWithTypeGroups.push(createRefSheetWithTypeGroup(refSheet, 'Complic', ['sctComplic1', 'sctComplic2'], isBio))
  })
  refSheetWithTypeGroups = refSheetWithTypeGroups.filter(Boolean)
  bioSuggestionsFromRefSheets.value = refSheetWithTypeGroups
}

function createRefSheetWithTypeGroup(refSheet, resultReferenceType, groups, filterFct) {
  const elements = groups
    .map(subGroup => 
      refSheet[subGroup]
        .filter(filterFct)              // Filter Lab-results
        .map(linkPrescribedExprToSugg)  // Link prescribedExpr to suggExpr
    )
    .filter(arr => arr.length)          //Filter out empty arrays ('elements' is an array of arrays)
  return elements.length
    ? { refSheet, resultReferenceType, elements }
    : null
}

const bioWithoutButtonArray = ref([]);
async function createLinkedBioGroups() {
  if (!currentEntryStore.hasCurrentEntry) return
  if (!appUserStore.currentAppUserData) return
  //notFoundPrescribed
  let ret = []
  //AFind existing buttons
  const bioIdsRefSheets = (bioSuggestionsFromRefSheets.value ?? [])
    .flatMap(obj => obj.elements)
    .flat()
    .map(expr => expr.expression_CclId);
  const bioIdsFromCcl = cclRow.value?.map(item => item.expression_CclId) ?? [];
  const bioWithButtonArray = [...bioIdsRefSheets, ...bioIdsFromCcl];

  prescribedBioExprs.value.forEach(prescribedExpr => {
    const hasUiButton = bioWithButtonArray.includes(prescribedExpr.expressionCcl.expressionCclId);
    if (!hasUiButton) {
      const newSugg = linkPrescribedExprAsNewSugg(prescribedExpr)   
      ret.push(newSugg)
    }   
  })
  bioWithoutButtonArray.value = ret;
}


function linkPrescribedExprAsNewSugg(prescribedExpr) {
  const ret = gen.deepCopy(prescribedExpr)
  ret.expression_CclId = ret.expressionCcl.expressionCclId
  ret.text = prescribedExpr.originalText
  ret.active = true
  return ret
}

function linkPrescribedExprToSugg(suggExpr) {
  //Test if suggExpr = prescribed (by lowerCase match)
  let foundPrescribedExpr = prescribedBioExprs.value.find(prescribedExpr => 
    prescribedExpr.originalText.toLowerCase() === suggExpr.originalText.toLowerCase()
  )
  //Gest if suggExpr = prescribed (by sctLabKey match)
  //Some item have the same sctLabkey do not filter by sctLabkey to avoid multiple selection
  /**if (!foundPrescribedExpr && suggExpr.isMatched) {
    foundPrescribedExpr = prescribedBioExprs.value.find(prescribedExpr => 
      prescribedExpr.sctLabKey === suggExpr.sctLabKey
    )
  }*/
  //Add details
  if (foundPrescribedExpr) {
    const ret = gen.deepCopy(foundPrescribedExpr)
    ret.expression_CclId = foundPrescribedExpr.expressionCcl.expressionCclId
    ret.text = suggExpr.originalText
    ret.active = true
    return ret
  } else {
    const ret = gen.deepCopy(suggExpr)
    ret.text = suggExpr.originalText
    ret.active = false
    return ret
  }
}

function reloadLocal() {
  getSuggestionsFromCclText();
  createBioSuggestionsFromRefSheet();
  createLinkedBioGroups();
}

async function flushPendingChangesAndReloadEntry() {
  if (pendingToDelete.size === 0 && pendingToAdd.size === 0) return;
  //Map and clear
  const deletions = Array.from(pendingToDelete.values());
  const additions = Array.from(pendingToAdd.values());
  pendingToDelete.clear();
  pendingToAdd.clear();  
  // Back - Process deletions in parallel
  await Promise.all(
    deletions.map(({ expression_CclId, entryId }) =>
      patientapi.deleteExpressionPrescription(expression_CclId, entryId)
    )
  );
  // Process additions
  await Promise.all(
    Object.entries(Object.groupBy(additions, a => a.conclusionGroupId))
      .map(([conclusionGroupId, items]) =>
        patientapi.addBioPrescriptionsToConclusion(conclusionGroupId, items.map(i => i.originalText))
      )
  );
  // Reload
  await currentEntryStore.reloadCurrentEntry();
}

async function prescribeBioFromInput() {
  const conclusionGroupId = currCclGroupId.value;
  const inputBioText = bioContentText.value.trim();
  if (!inputBioText) return;
  //Update frontend
  clearBioSearch();
  //Update backend
  await patientapi.addBioPrescriptionsToConclusion(conclusionGroupId, [inputBioText]);
  //Reload frontend
  if (pendingToDelete.size === 0 && pendingToAdd.size === 0) {
    await currentEntryStore.reloadCurrentEntry();
  } else {
    await flushPendingChangesAndReloadEntry();
  }
  reloadLocal()
}

watch(
  () => [
    dropd.value,
  ],
  async () => {
    //When dropdown (Biolists) closes
    if (dropd.value === "") {
      reloadLocal()
    //When dropdon (Biolists) opens
    } else {
      await flushPendingChangesAndReloadEntry();
    }
  },
  { immediate: true }
)

watch(
  () => [
    appUserStore.currentAppUserData,
    currentEntryStore.currentCcl?.conclusionGroupId,
    currentEntryStore.currCclSuggestionsFromCclText,
    currentEntryStore.currCclSuggestionsFromResults,
  ],
  async () => {
    await flushPendingChangesAndReloadEntry();
    reloadLocal();
  },
  { immediate: true }
)

onBeforeUnmount(async () => {
  await flushPendingChangesAndReloadEntry();
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_listGroup = _resolveComponent("listGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.common.biology'),
        styles: "font-mBold"
      }, null, 8, ["txt"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
        openOn: "PrescribeBioFromLists"
      }, {
        dropd: _withCtx(() => [
          _createVNode(docBioAddLists)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_buttonGroup, { class: "mleft-02" }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "plus",
                styles: "main-m"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_inputComboBox2, {
          ref_key: "bioInputRef",
          ref: bioInputRef,
          class: "mtop-04",
          modelValue: bioContentText.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((bioContentText).value = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (prescribeBioFromInput()), ["enter"])),
          style: {"width":"100%"},
          hasDropd: false
        }, {
          post: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "line-v" }, null, -1)),
            _createVNode(_component_buttonGroup, {
              theme: "inline",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (prescribeBioFromInput())),
              center: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "check",
                  styles: "size-l"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bioSuggestionsFromRefSheets.value, (resultGroup, resultIndex) => {
        return (_openBlock(), _createBlock(refSheetGroup, {
          key: resultIndex,
          class: "mtop-10",
          refSheet: resultGroup.refSheet,
          resultReferenceType: resultGroup.resultReferenceType,
          showType: true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultGroup.elements, (row, rowIndex) => {
              return (_openBlock(), _createBlock(_component_listGroup, {
                key: rowIndex,
                active: false,
                class: "pad-0 w-full flexwrap",
                style: {"gap":"0.07rem"},
                onClick: ($event: any) => (switchBioRowPrescription(row))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (expr, exprIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: exprIndex,
                        class: "row"
                      }, [
                        (exprIndex !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                          : _createCommentVNode("", true),
                        _createVNode(_component_switchGroup, {
                          styles: "padButton-s",
                          style: {"padding":"0rem 0.5rem"},
                          active: expr.active,
                          onClick: _withModifiers(($event: any) => (switchSingleBioPrescription(row, exprIndex)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_text_item, {
                                txt: expr.text,
                                styles: "main-m",
                                class: _normalizeClass([expr.active ? 'txt-white' : '', "es-suggestion-txt"])
                              }, null, 8, ["txt", "class"]),
                              (expr.isMatched == true)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "mleft-04",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    (_unref(currentEntryStore).showAnnotations)
                                      ? (_openBlock(), _createBlock(_component_itemModal, {
                                          key: 0,
                                          center: true,
                                          uiId: expr.originalText
                                        }, {
                                          modal: _withCtx(() => [
                                            _createVNode(showAnnotations, { content: expr }, null, 8, ["content"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              src: _imports_0,
                                              class: _normalizeClass(["size-m main-l", expr.active ? 'img-white' : 'img-grey'])
                                            }, null, 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["uiId"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["active", "onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["refSheet", "resultReferenceType"]))
      }), 128)),
      (cclRow.value)
        ? (_openBlock(), _createBlock(refSheetGroup, {
            key: 0,
            class: "mtop-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_listGroup, {
                active: false,
                class: "pad-0 w-full flexwrap",
                style: {"gap":"0.07rem"},
                onClick: _cache[6] || (_cache[6] = ($event: any) => (switchBioRowPrescription(cclRow.value)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cclRow.value, (expr, exprIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: exprIndex,
                        class: "row"
                      }, [
                        (exprIndex !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                          : _createCommentVNode("", true),
                        _createVNode(_component_switchGroup, {
                          styles: "padButton-s",
                          style: {"padding":"0rem 0.5rem"},
                          active: expr.active,
                          onClick: _withModifiers(($event: any) => (switchSingleBioPrescription(cclRow.value, exprIndex)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_text_item, {
                                txt: expr.text,
                                styles: "main-m",
                                class: _normalizeClass(expr.active ? 'txt-white' : '')
                              }, null, 8, ["txt", "class"]),
                              (expr.isMatched == true)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "mleft-04",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    (_unref(currentEntryStore).showAnnotations)
                                      ? (_openBlock(), _createBlock(_component_itemModal, {
                                          key: 0,
                                          center: true,
                                          uiId: expr.originalText
                                        }, {
                                          modal: _withCtx(() => [
                                            _createVNode(showAnnotations, { content: expr }, null, 8, ["content"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              src: _imports_0,
                                              class: _normalizeClass(["size-m main-l", expr.active ? 'img-white' : 'img-grey'])
                                            }, null, 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["uiId"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["active", "onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (bioWithoutButtonArray.value.length)
        ? (_openBlock(), _createBlock(refSheetGroup, {
            key: 1,
            title: "Prescrit",
            class: "mtop-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_listGroup, {
                active: false,
                class: "pad-0 w-full flexwrap",
                style: {"gap":"0.07rem"},
                onClick: _cache[8] || (_cache[8] = ($event: any) => (switchBioRowPrescription(bioWithoutButtonArray.value)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bioWithoutButtonArray.value, (expr, exprIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: exprIndex,
                        class: "row"
                      }, [
                        (exprIndex !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                          : _createCommentVNode("", true),
                        _createVNode(_component_switchGroup, {
                          styles: "padButton-s",
                          style: {"padding":"0rem 0.5rem"},
                          active: expr.active,
                          onClick: _withModifiers(($event: any) => (switchSingleBioPrescription(bioWithoutButtonArray.value, exprIndex)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_text_item, {
                                txt: expr.text,
                                styles: "main-m",
                                class: _normalizeClass(expr.active ? 'txt-white' : '')
                              }, null, 8, ["txt", "class"]),
                              _createElementVNode("div", {
                                class: "mleft-04",
                                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (_unref(currentEntryStore).showAnnotations)
                                  ? (_openBlock(), _createBlock(_component_itemModal, {
                                      key: 0,
                                      center: true,
                                      uiId: expr.originalText
                                    }, {
                                      modal: _withCtx(() => [
                                        _createVNode(showAnnotations, { content: expr }, null, 8, ["content"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: _imports_0,
                                          class: _normalizeClass(["size-m main-l", expr.active ? 'img-white' : 'img-grey'])
                                        }, null, 2)
                                      ]),
                                      _: 2
                                    }, 1032, ["uiId"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["active", "onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})